import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChip"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM9 19V17.5H7V19H5V5H7V6.5H9V5H11V6.5H13V5H15V6.5H17V5H19V19H17V17.5H15V19H13V17.5H11V19H9ZM7 8H17V16H7V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChip;
